<template>
  <section id="state-pc-movement">
    <figure class="chart">
      <div class="row clearfix">
        <h1>Percentage Movement by State</h1>

        <ul class="switches">
          <li v-for="(year, index) in years" :key="index">
            <a href="javascript:;" :class="{active: activeYear==year}" @click="activeYear=year">{{ year }}</a>
          </li>
        </ul>

        <highcharts class="graphcontainer" :options="activeReport"></highcharts>
      </div>
    </figure>

    <figure id="state-pc-movement-table" class="data">
      <div class="row clearfix">
        <a href="#" data-table="state-pc-movement-table" class="closetable" title="Close Table">Close Table</a>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Lime Cordiale and the Melbourne Symphony Orchestra</em>, Melbourne Symphony Orchestra, Photo Credit: Mark Gambino.</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */
export default {
  data () {
    return {
      activeYear: '2024 - 2025',
      years: [
        '2011 - 2012',
        '2012 - 2013',
        '2013 - 2014',
        '2014 - 2015',
        '2015 - 2016',
        '2016 - 2017',
        '2017 - 2018',
        '2018 - 2019',
        '2019 - 2020',
        '2020 - 2021',
        '2021 - 2022',
        '2022 - 2023',
        '2023 - 2024',
        '2024 - 2025',
      ],
      reports: [
        {
          year: '2024 - 2025',
          revenue: [ {y: -1.7}, {y: -3.8}, {y: -1.5}, {y: 19.1}, {y: 8.1}, {y: 26.3}, {y: -5.0}, {y: 2.1} ],
          attendance: [ {y: -4.2}, {y: -3.5}, {y: -5.5}, {y: 4.3}, {y: 4.2}, {y: 8.3}, {y: 26.7}, {y: -27.8} ],
        },
        {
          year: '2023 - 2024',
          revenue: [ {y: 16.3}, {y: 14.9}, {y: -4.7}, {y: -20.2}, {y: -3.3}, {y: -17.7}, {y: 4.1}, {y: -4.4} ],
          attendance: [ {y: 10.9}, {y: 7.4}, {y: 0.1}, {y: -10.0}, {y: 1.5}, {y: -1.8}, {y: -19.2}, {y: 48.3} ],
        },
        {
          year: '2022 - 2023',
          revenue: [ {y: 54.4}, {y: 43.9}, {y: 78.0}, {y: 94.7}, {y: 53.8}, {y: 11.1}, {y: 15.1}, {y: 26.8} ],
          attendance: [ {y: 26.6}, {y: 17.1}, {y: 32.4}, {y: 45.1}, {y: 19.7}, {y: -2.7}, {y: -7.4}, {y: 5.2} ],
        },
        {
          year: '2021 - 2022',
          revenue: [
            {y: 211.3},
            {y: 333.3},
            {y: 128.0},
            {y: 88.9},
            {y: 117.6},
            {y: 173.0},
            {y: 78.0},
            {y: 32.1}
          ],
          attendance: [
            {y: 178.5},
            {y: 231.2},
            {y: 68.4},
            {y: 36.3},
            {y: 52.6},
            {y: 86.8},
            {y: 52.7},
            {y: 11.2}
          ],
        },
        {
          year: '2020 - 2021',
          revenue: [
            {y: 19.0},
            {y: -0.2},
            {y: 13.7},
            {y: 16.8},
            {y: -9.2},
            {y: 112.5},
            {y: 52.8},
            {y: 517.4}
          ],
          attendance: [
            {y: 33.0},
            {y: 53.3},
            {y: 75.6},
            {y: 26.6},
            {y: -2.0},
            {y: 109.9},
            {y: 89.1},
            {y: 395}
          ],
        },
        {
          year: '2019 - 2020',
          revenue: [
            {y: -72.6},
            {y: -74.8},
            {y: -59.2},
            {y: -62.5},
            {y: -55.3},
            {y: -81.9},
            {y: -58.7},
            {y: -68.0}
          ],
          attendance: [
            {y: -72.6},
            {y: -79.1},
            {y: -63.7},
            {y: -51.4},
            {y: -39.9},
            {y: -76.6},
            {y: -47.0},
            {y: -61.5}
          ],
        },
        {
          year: '2018 - 2019',
          revenue: [
            {y: -11.5},
            {y: 4.5},
            {y: -9.8},
            {y: -8.2},
            {y: 1.4},
            {y: 13.2},
            {y: 18.8},
            {y: -9.2}
          ],
          attendance: [
            {y: -13.0},
            {y: -1.5},
            {y: -9.5},
            {y: -4.5},
            {y: 4.7},
            {y: 6.4},
            {y: -52.5},
            {y: -4.2}
          ],
        },
        {
          year: '2017 - 2018',
          revenue: [ {y: 22.4}, {y: 9.2}, {y: 20.2}, {y: 7.5}, {y: 6.5}, {y: 12.3}, {y: 17.0}, {y: -12.8} ],
          attendance: [ {y: 19.4}, {y: 8.6}, {y: 20.1}, {y: 6.5}, {y: 5.4}, {y: 12.6}, {y: 67.1}, {y: 1.9} ],
        },
        {
          year: '2016 - 2017',
          revenue: [ {y: 16.2}, {y: 45.3}, {y: 46.4}, {y: 33.1}, {y: 31.0}, {y: 26.7}, {y: 9.9}, {y: 6.6} ],
          attendance: [ {y: 13.5}, {y: 35.6}, {y: 26.5}, {y: 11.5}, {y: 16.9}, {y: 15.0}, {y: 84.3}, {y: 2.0} ],
        },
        {
          year: '2015 - 2016',
          revenue: [ {y: 10.9}, {y: 0.8}, {y: -7.7}, {y: -12.4}, {y: -2.6}, {y: -16.8}, {y: 38.5}, {y: -2.3} ],
          attendance: [ {y: 8.6}, {y: -2.1}, {y: -13.3}, {y: 5.3}, {y: 5.7}, {y: -15.9}, {y: 13.7}, {y: -6.8} ],
        },
        {
          year: '2014 - 2015',
          revenue: [ {y: -12.6}, {y: -2.9}, {y: -4.2}, {y: -8.4}, {y: -4.1}, {y: 69.7}, {y: -8.3}, {y: 3.4} ],
          attendance: [ {y: -8.8}, {y: 4.3}, {y: 9.5}, {y: -13.1}, {y: 5.3}, {y: 51.1}, {y: 13.9}, {y: -37} ],
        },
        {
          year: '2013 - 2014',
          revenue: [ {y: 10}, {y: -5}, {y: 1.9}, {y: -8.7}, {y: 7.5}, {y: -8.3}, {y: 382.8}, {y: 45.9} ],
          attendance: [ {y: 4.6}, {y: -5.2}, {y: 14.8}, {y: 5.2}, {y: 7.8}, {y: -29.8}, {y: 146.3}, {y: 91.7} ],
        },
        {
          year: '2012 - 2013',
          revenue: [ {y: 11.5}, {y: 37.5}, {y: 8.9}, {y: 44.9}, {y: 27.6}, {y: -12.7}, {y: -43.1}, {y: 44.9} ],
          attendance: [ {y: 1.2}, {y: 14.1}, {y: 0.7}, {y: 20.2}, {y: 42.1}, {y: 29.4}, {y: -23.3}, {y: 32.8} ],
        },
        {
          year: '2011 - 2012',
          revenue: [ {y: -14.9}, {y: -10.7}, {y: 10.8}, {y: 1.7}, {y: -4.8}, {y: 6.9}, {y: -37.4}, {y: -14.8} ],
          attendance: [ {y: -8.5}, {y: -8.3}, {y: 7.1}, {y: 0.2}, {y: -14.8}, {y: -16.5}, {y: -1.7}, {y: -19.3} ],
        },
      ],
    }
  },
  computed: {
    activeReport () {
      const self = this

      for (let i = 0; i < self.reports.length; i++) {
        const report = self.reports[i]
        if (report.year === self.activeYear) {
          return {
            chart: {
              type: 'bar',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            xAxis: {
              title: {
                text: ''
              },
              categories: [
                'New South Wales',
                'Victoria',
                'Queensland',
                'Western Australia',
                'South Australia',
                'Australian Capital Territory',
                'Tasmania',
                'Northern Territory'
              ],
              labels: {
                style: {
                  color: '#fff'
                }
              }
            },
            yAxis: {
              title: {
                text: 'Percentage Change',
                style: {
                  color: '#fff'
                }
              },
              valueSuffix: '%',
              labels: {
                style: {
                  color: '#fff'
                }
              }
            },
            series: [
              {
                name: 'Change in Attendance',
                data: report.attendance,
                color: '#d14967'
              },
              {
                name: 'Change in Revenue',
                data: report.revenue,
                color: '#3a89eb'
              }
            ],
            legend: {
              layout: 'vertical',
              align: 'center',
              verticalAlign: 'bottom',
              floating: false,
              backgroundColor: '#FFFFFF'
            },
            tooltip: {
              shared: true,
              valueSuffix: '%',
              followPointer: true,
              valueDecimals: 1
            }
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
#state-pc-movement .fullbg {
  background-image: url("~@/assets/img/2025/5-Percentage-Movement-Lime-Cordiale-&-the-MSO-2025-cr-Mark-Gambino.jpg");
}
</style>
